<template>
  <div>
   
	<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
       
         <div class="row">
            <div class="col-lg-12">
              <h5 style="padding: 20px 20px 0px;">OFFER INFORMATION</h5><hr>
        <div class="card mb-4">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0"><b>Full Name</b></p>
              </div>
              <div class="col-sm-9">
                <p class="text-muted mb-0">{{ name }}</p>
              </div>
            </div>
            <hr v-if="this.roleid == 3" >
            <div v-if="this.roleid == 3" class="row">
              <div class="col-sm-3">
                <p class="mb-0"><b>Shop Name</b></p>
              </div>
              <div class="col-sm-9">
                <p class="text-muted mb-0">{{ shopname }}</p>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0"><b>Email</b></p>
              </div>
              <div class="col-sm-9">
                <p class="text-muted mb-0">{{ email }}</p>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0"><b>Mobile</b></p>
              </div>
              <div class="col-sm-9">
                <p class="text-muted mb-0">{{ mobile }}</p>
              </div>
            </div>
            <hr>
          
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0"><b>Offer Price</b></p>
              </div>
              <div class="col-sm-9">
                <p class="text-muted mb-0">{{ offerprice }}</p>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0"><b>Offers</b></p>
              </div>
              <div class="col-sm-9">
                <p class="text-muted mb-0">{{ offertext }}</p>
              </div>
            </div>
          </div>
        </div>
          </div></div>
    </div>
  </div>
</div>
    <Frontendlayout>
      <!--/hero_in-->
        <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Notification</h1>
          </div>
        </div>
      </section>
        <div class="container-fluid">
          <div class="row">
            <Sidebar />
			<div class="col-lg-10"> 
        <div class="box_general">
				<div class="row">
					<div class="col-lg-12">
						<div class="box_cart">
				<table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0">
                  <thead>
                    <tr>
                      <th >Sno.</th>
                      <th>Type</th>
                      <th >Name</th>
                      <th >Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list, index) in lists" :key="index">
						<td>{{index+1}}</td>
						<td>{{list.post_name.toUpperCase()}}</td>
						<td>{{list.firstname.toUpperCase()}}</td>
						<td>{{frontEndDateFormat(list.timestamp)}}</td>
						<td>
              <a v-if="list.status==1" :class="noticlass" :id="index" href="javascript:void(0);" @click="openModal(list.serder_id,list.id,list.role_id,list.offer_price,list.offer_summary,list.status,index)" >{{noticlass}}</a>
              <a v-else class="Read" :id="index" href="javascript:void(0);" @click="openModal(list.serder_id,list.id,list.role_id,list.offer_price,list.offer_summary,list.status,index)" >Read</a>
            </td>
                    </tr>
                  </tbody>
                </table>
			<!-- /cart-options -->
					</div>
					</div>
					<!-- /col -->
					
				</div></div>
				<!-- /row -->
			</div>
			<!-- /container -->
		</div>
            <!-- /col -->
          <!-- /row -->
        </div>
        <!-- /container -->
      

      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
// import Alert from "../cmps/Alert";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "jquery/dist/jquery.min.js";
import API from "../services/index";
import jQuery from 'jquery';
import moment from "moment";


import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";

export default {
  data() {
    return {
    lists: [], 
	dt: null,
  noticlass:'New',
	userData:{},
	userDob: null,
  name:'',
  shopname:'',
  email:'',
  mobile:'',
  offerprice:'',
  offertext:'',
  roleid:'',
    };
  },
  beforeMount() {
     if(localStorage.getItem("token")!=null){
    const token = "Bearer " + localStorage.getItem("token");
    API.get("Sendrequirement/notification", {
          headers: { Authorization: token },
        })
        .then((res) => {
             this.lists= res.data.data
             this.roleid = res.data.role_id
			this.dt = jQuery(".table").DataTable();

        })
        .catch((err) => {
          console.log(err);
        });

    }else{
		this.$router.push('/signin')
	}
  },
watch: {
    lists() {
      this.dt.destroy();
      this.$nextTick(() => {
        this.dt = jQuery(".table").DataTable();
      });
    },
  },
  methods: {  
    frontEndDateFormat(date) {
      //alert(date);
      return moment(date).format("DD/MMMM/YYYY h:mm A");
    },
    notificationStatus(id){
      const token = "Bearer " + localStorage.getItem("token");

      API.get(`/Sendrequirement/notification_status_change/${id}`, {
        headers: { Authorization: token },
      }).then((response) => {
          console.log(response.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
	openModal(serder_id,id,role_id,offer_price,offer_summary,nstatus,index){
   window.$(`#${index}`).attr('class', 'Read');
   window.$(`#${index}`).text('Read');
   if(nstatus == 1){
      this.notificationStatus(id);
    }
    
     this.offerprice=offer_price
          this.offertext=offer_summary
	window.$('.bd-example-modal-lg').modal('show')
	const token = "Bearer " + localStorage.getItem("token");
  const form = new FormData();
      form.append("login_id", btoa(serder_id));
      form.append("role_id", role_id);

      API.post("/profile/role_wise_userDetails", form, {
        headers: { Authorization: token },
      })
        .then((response) => {
          this.userData = response.data.data[0];
          this.name = this.userData.first_name+' '+this.userData.last_name;
          this.shopname = this.userData.company_name;
          this.email = this.userData.primary_email;
          this.mobile = this.userData.mobile_1;
          this.userDob = this.$root.frontEndDateFormat(this.userData.dob);
          
		
        })
        .catch((err) => {
          console.log(err.response);
        });
	}
    },
  components: {
    Frontendlayout,
    Sidebar,
  },

};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

a.New{
 
    background:#2dc02d;
    color: #fff;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 12px;
  
}
a.Read{
 
    background:#8363db;
    color: #fff;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 12px;
  
}
hr {
    margin: 20px 0;
    border-color: #ededed;
}
</style>